module.exports = __webpack_public_path__ + "static/media/31JFA12.268f542c.jpg";